import { Stack, useTheme, Divider } from '@mui/material';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { Button, IconButton, Typography } from '@chr/eds-react';
import { IconType } from '@chr/eds-react/Icon';
import { Document } from '@/common/apis/dtos';
import { ProgressButton } from '@/common/components/progress-button/ProgressButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export interface DocumentActionBarProps {
  isDownloading: boolean,
  documentCount: number,
  selectedDocuments: Document[],
  showMaxSelected: boolean,
  closeActionBar: () => void,
  handleEmailDocuments: (docs:Document[]) => void,
  handleDownloadDocuments: (docs: Document[]) => void,
}

export const DocumentActionBar = ({
  isDownloading,
  documentCount,
  selectedDocuments,
  showMaxSelected,
  closeActionBar,
  handleEmailDocuments,
  handleDownloadDocuments,
}: DocumentActionBarProps) => {
  const theme = useTheme();
  const translate = useTranslation();

  return (
    <>
      <Stack
        sx={{
          backgroundColor: theme.palette.primary.dark,
          borderRadius: '4px',
          '.MuiButtonBase-root': {
            backgroundColor: theme.palette.primary.dark, 
            color: "#fff",
          }
        }}
        direction={'row'}
        justifyContent="space-between"
        alignItems="center"
        padding={1}
        data-testid="document-action-bar"
      >
        <Stack 
          direction={'row'}
          alignItems='center'
          spacing={2}
        >
          <IconButton 
            id='close-action-bar'
            aria-label='action-bar-close-button'
            icon='close'
            onClick={closeActionBar}
            variant="tertiary"
          />
          <Typography variant="body100" color='white'>{`Selected ${selectedDocuments.length} of ${documentCount}`}</Typography>
          {showMaxSelected && (
            <Stack direction={'row'}>
              <Divider flexItem orientation='vertical' sx={{ marginRight: 2 }} />
              <InfoOutlinedIcon fontSize='large' sx={{ color: 'white', marginRight: '2px' }} />
              <Typography data-testid='max-doc-reached' variant="body100" color='white'>{translate('You can select a maximun of 20 documents for bulk actions.')}</Typography>
            </Stack>
          )}          
        </Stack>

        <Stack
          direction='row'
          alignItems='center'
          spacing={2}
        >
          <Button 
            variant="tertiary"
            aria-label="Email Documents"
            startIcon={"email" as IconType}
            buttonText={translate('Email')}
            onClick={() => handleEmailDocuments(selectedDocuments)}
          />
          <ProgressButton
            showProgress={isDownloading}
            buttonText={translate('Download')}
            onClick={() => handleDownloadDocuments(selectedDocuments)}
            variant="tertiary"
            startIcon='download'
            iconVariant='outlined'
          />
        </Stack>
      </Stack>
    </>
  );
}